/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Proofreading API
 * PR TIMES 校正 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProofreadingResultMessage,
    ProofreadingResultMessageFromJSON,
    ProofreadingResultMessageFromJSONTyped,
    ProofreadingResultMessageToJSON,
} from './ProofreadingResultMessage';

/**
 * GET /lint/{lint_id}
 * @export
 * @interface ProofreadingGetLintResultsResponse
 */
export interface ProofreadingGetLintResultsResponse {
    /**
     * 
     * @type {number}
     * @memberof ProofreadingGetLintResultsResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ProofreadingGetLintResultsResponse
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ProofreadingGetLintResultsResponse
     */
    lintStatus?: ProofreadingGetLintResultsResponseLintStatusEnum;
    /**
     * 校正結果リスト (リクエストで送信した bulk_text の結果が順番に格納される)
     * @type {Array<Array<ProofreadingResultMessage>>}
     * @memberof ProofreadingGetLintResultsResponse
     */
    results: Array<Array<ProofreadingResultMessage>>;
}

/**
* @export
* @enum {string}
*/
export enum ProofreadingGetLintResultsResponseLintStatusEnum {
    Done = 'done',
    Processing = 'processing',
    Failed = 'failed'
}

export function ProofreadingGetLintResultsResponseFromJSON(json: any): ProofreadingGetLintResultsResponse {
    return ProofreadingGetLintResultsResponseFromJSONTyped(json, false);
}

export function ProofreadingGetLintResultsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProofreadingGetLintResultsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'lintStatus': !exists(json, 'lint_status') ? undefined : json['lint_status'],
        'results': json['results'],
    };
}

export function ProofreadingGetLintResultsResponseToJSON(value?: ProofreadingGetLintResultsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'lint_status': value.lintStatus,
        'results': value.results,
    };
}

